var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrap wrap--products"
  }, [_c('main-header'), _vm._m(0), _c('main-footer')], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', {
    staticClass: "main",
    attrs: {
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "product-list-container"
  }, [_c('nav', {
    staticClass: "product-categories"
  }, [_c('ul', {
    staticClass: "product-category"
  }, [_c('li', {
    staticClass: "product-category__list"
  }, [_c('a', {
    staticClass: "product-category__list-link",
    attrs: {
      "href": ""
    }
  }, [_c('span', [_vm._v("카테고리 전체")])])]), _c('li', {
    staticClass: "product-category__list"
  }, [_c('a', {
    staticClass: "product-category__list-link",
    attrs: {
      "data-toggle": "opened"
    }
  }, [_c('i', {
    staticClass: "arrow"
  }), _c('span', [_vm._v("강아지")])]), _c('ul', {
    staticClass: "product-category__level product-category__level--1"
  }, [_c('li', [_c('a', {
    staticClass: "product-category__level-link",
    attrs: {
      "data-toggle": "opened"
    }
  }, [_c('span', [_vm._v("사료")])]), _c('ul', {
    staticClass: "product-category__level product-category__level--2"
  }, [_c('li', [_c('a', {
    staticClass: "on",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("수제간식")])])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("덴탈껌")])])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("져키/트릿")])])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("동결건조")])])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("파우더")])])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("캔/파우치")])])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("영양제")])])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("쿠키")])])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("소시지")])])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("펫드링크")])])])])]), _c('li', [_c('a', {
    staticClass: "product-category__level-link",
    attrs: {
      "data-toggle": "closed"
    }
  }, [_c('span', [_vm._v("간식")])])]), _c('li', [_c('a', {
    staticClass: "product-category__level-link",
    attrs: {
      "data-toggle": "closed"
    }
  }, [_c('span', [_vm._v("용품")])])])])]), _c('li', {
    staticClass: "product-category__list"
  }, [_c('a', {
    staticClass: "product-category__list-link",
    attrs: {
      "data-toggle": "closed"
    }
  }, [_c('i', {
    staticClass: "arrow"
  }), _c('span', [_vm._v("고양이")])])])])]), _c('section', {
    staticClass: "product-lists"
  }, [_c('div', {
    staticClass: "product-lists__head"
  }, [_c('div', {
    staticClass: "product-lists__total"
  }, [_c('span', [_c('em', [_vm._v("1,000")]), _vm._v(" 개의 상품이 있습니다.")])]), _c('div', {
    staticClass: "product-lists__order"
  }, [_c('div', {
    staticClass: "product-lists__group"
  }, [_c('ul', {
    staticClass: "product-lists__group-lists"
  }, [_c('li', [_c('a', {
    staticClass: "on",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("베스트")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("신상품")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("높은 가격순")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("낮은 가격순")])])])]), _c('div', {
    staticClass: "product-lists__select"
  }, [_c('select', {
    staticClass: "product-lists__select-option",
    attrs: {
      "name": "",
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("20개 보기")])])])])]), _c('div', {
    staticClass: "product-lists__body"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "grid-8"
  }, [_c('a', {
    staticClass: "product-list",
    attrs: {
      "href": "/shop/products/view"
    }
  }, [_c('span', {
    staticClass: "product-list__thumb"
  }, [_c('img', {
    staticClass: "product-list__thumbnail",
    attrs: {
      "src": "/images/sample/product-thumbnail-medium.jpg",
      "alt": ""
    }
  })]), _c('span', {
    staticClass: "product-list__title"
  }, [_vm._v("[2+1] 반려소반 바른트릿 그린홍합 50g, 2개 + 맛선택 1개")]), _c('span', {
    staticClass: "product-list__price"
  }, [_c('span', {
    staticClass: "product-list__price-left"
  }, [_c('em', {
    staticClass: "product-list__price-num"
  }, [_vm._v("15,000")]), _vm._v("원 "), _c('span', {
    staticClass: "product-list__price-percent"
  }, [_vm._v("25%")])])])])]), _c('div', {
    staticClass: "grid-8"
  }, [_c('a', {
    staticClass: "product-list",
    attrs: {
      "href": "/shop/products/view"
    }
  }, [_c('span', {
    staticClass: "product-list__thumb"
  }, [_c('img', {
    staticClass: "product-list__thumbnail",
    attrs: {
      "src": "/images/sample/product-thumbnail-medium.jpg",
      "alt": ""
    }
  })]), _c('span', {
    staticClass: "product-list__title"
  }, [_vm._v("[2+1] 반려소반 바른트릿 그린홍합 50g, 2개 + 맛선택 1개")]), _c('span', {
    staticClass: "product-list__price"
  }, [_c('span', {
    staticClass: "product-list__price-left"
  }, [_c('em', {
    staticClass: "product-list__price-num"
  }, [_vm._v("15,000")]), _vm._v("원 "), _c('span', {
    staticClass: "product-list__price-percent"
  }, [_vm._v("25%")])])])])]), _c('div', {
    staticClass: "grid-8"
  }, [_c('a', {
    staticClass: "product-list",
    attrs: {
      "href": "/shop/products/view"
    }
  }, [_c('span', {
    staticClass: "product-list__thumb"
  }, [_c('img', {
    staticClass: "product-list__thumbnail",
    attrs: {
      "src": "/images/sample/product-thumbnail-medium.jpg",
      "alt": ""
    }
  })]), _c('span', {
    staticClass: "product-list__title"
  }, [_vm._v("[2+1] 반려소반 바른트릿 그린홍합 50g, 2개 + 맛선택 1개")]), _c('span', {
    staticClass: "product-list__price"
  }, [_c('span', {
    staticClass: "product-list__price-left"
  }, [_c('em', {
    staticClass: "product-list__price-num"
  }, [_vm._v("15,000")]), _vm._v("원 "), _c('span', {
    staticClass: "product-list__price-percent"
  }, [_vm._v("25%")])])])])]), _c('div', {
    staticClass: "grid-8"
  }, [_c('a', {
    staticClass: "product-list",
    attrs: {
      "href": "/shop/products/view"
    }
  }, [_c('span', {
    staticClass: "product-list__thumb"
  }, [_c('img', {
    staticClass: "product-list__thumbnail",
    attrs: {
      "src": "/images/sample/product-thumbnail-medium.jpg",
      "alt": ""
    }
  })]), _c('span', {
    staticClass: "product-list__title"
  }, [_vm._v("[2+1] 반려소반 바른트릿 그린홍합 50g, 2개 + 맛선택 1개")]), _c('span', {
    staticClass: "product-list__price"
  }, [_c('span', {
    staticClass: "product-list__price-left"
  }, [_c('em', {
    staticClass: "product-list__price-num"
  }, [_vm._v("15,000")]), _vm._v("원 "), _c('span', {
    staticClass: "product-list__price-percent"
  }, [_vm._v("25%")])])])])]), _c('div', {
    staticClass: "grid-8"
  }, [_c('a', {
    staticClass: "product-list",
    attrs: {
      "href": "/shop/products/view"
    }
  }, [_c('span', {
    staticClass: "product-list__thumb"
  }, [_c('img', {
    staticClass: "product-list__thumbnail",
    attrs: {
      "src": "/images/sample/product-thumbnail-medium.jpg",
      "alt": ""
    }
  })]), _c('span', {
    staticClass: "product-list__title"
  }, [_vm._v("[2+1] 반려소반 바른트릿 그린홍합 50g, 2개 + 맛선택 1개")]), _c('span', {
    staticClass: "product-list__price"
  }, [_c('span', {
    staticClass: "product-list__price-left"
  }, [_c('em', {
    staticClass: "product-list__price-num"
  }, [_vm._v("15,000")]), _vm._v("원 "), _c('span', {
    staticClass: "product-list__price-percent"
  }, [_vm._v("25%")])])])])])]), _c('div', {
    staticClass: "product-lists__pagination"
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('a', {
    staticClass: "pagination__backward",
    attrs: {
      "href": ""
    }
  }), _c('a', {
    staticClass: "pagination__prev",
    attrs: {
      "href": ""
    }
  }), _c('a', {
    staticClass: "current"
  }, [_vm._v("1")]), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("2")]), _c('a', {
    staticClass: "pagination__next",
    attrs: {
      "href": ""
    }
  }), _c('a', {
    staticClass: "pagination__forward",
    attrs: {
      "href": ""
    }
  })])])])])])])]);

}]

export { render, staticRenderFns }